/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MinimalUser } from './MinimalUser';
export type TherapistUserLinkingWithUserInfo = {
    role: TherapistUserLinkingWithUserInfo.role;
    user: MinimalUser;
};
export namespace TherapistUserLinkingWithUserInfo {
    export enum role {
        OWNER = 'owner',
        ADMIN = 'admin',
        PRACTITIONER = 'practitioner',
        ASSISTANT = 'assistant',
        VIEWER = 'viewer',
        THERAPIST = 'therapist',
        USER = 'user',
    }
}

